import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';

import { restorePayment } from '../../api';

export const useMutationRestorePayment = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const { t } = useTranslation();

  return useMutation(restorePayment, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS);

      successToast(t('Item successfully restored'));
    },
    onError: () => errorToast(),
  });
};
